// READ ME PLEASE:
//     THIS FILE IS A GENERATED. AND SHOULD BE GITIGNORED
//     YOU PROBABLY DO NOT WANT TO ALTER IT. IT'll WASTE YOUR TIME.
//     If it needs changes please set up a model that inherits and overrides
//     the behavior.

import {BaseModel} from '../Core/BaseModel';

import * as validators from '../Core/Validators';

import {
	PasswordsMatchValidator,
	RequiredValidator,
	PasswordRequiredValidator,
	MaxLengthValidator,
	NumericValidator,
	UnsignedNumberValidator,
} from '../Core/Validators';
import * as listOverrides from '../Extensions/Core/ListOverrides'
import {ConservationActionConfirmationStatusList} from '../Extensions/Core/ConservationActionConfirmationStatusList'
import {StreamBankConservationActionPermitList} from '../../Components/Common/StreamBankConservationActionPermitList'

import {Location} from './Location';
import {ConservationActionSampleEvent} from './ConservationActionSampleEvent';
import {ConservationActionType} from './ConservationActionType';
import {ConservationActionConfirmationStatus} from './ConservationActionConfirmationStatus';
import {ConservationActionPermit} from './ConservationActionPermit';
import {ContextNodeDetails} from './ContextNodeDetails';

const _associations = [
			{
				name: 'Location',
				model: new Location(),
				type: 'ParentPointer',
				using: 'locationId',
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: true,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 2,
				itemTitle: 'Location',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
			{
				name: 'ConservationActionSampleEvents',
				model: new ConservationActionSampleEvent(),
				type: 'ArrayOfChildren',
				using: 'conservationActionId',
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: false,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: false,
				isMutable: true,
				requiresPermission: null,
				group: 'Modeled Uplift',
				groupTitle: 'Modeled Uplift',
				displayOrder: 10,
				itemTitle: 'Modeled Uplift',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: listOverrides.NoHeaderStreamBankMutableList,
				customData: {
				}
			},
			{
				name: 'ConservationActionType',
				model: new ConservationActionType(),
				type: 'ParentPointer',
				using: 'conservationActionTypeId',
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: true,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: '',
				groupTitle: null,
				itemTitle: 'ConservationActionType',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
			{
				name: 'ConservationActionConfirmationStatuses',
				model: new ConservationActionConfirmationStatus(),
				type: 'ArrayOfChildren',
				using: 'conservationActionId',
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: false,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: false,
				isMutable: true,
				requiresPermission: null,
				group: 'Confirmation Status',
				groupTitle: 'Confirmation Status',
				displayOrder: 10,
				itemTitle: 'Confirmation Status',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: ConservationActionConfirmationStatusList,
				customData: {
				}
			},
			{
				name: 'ConservationActionPermits',
				model: new ConservationActionPermit(),
				type: 'ArrayOfChildren',
				using: 'conservationActionId',
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: false,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: false,
				isMutable: true,
				requiresPermission: null,
				group: 'Permits',
				groupTitle: '',
				displayOrder: 5,
				itemTitle: 'Permit Relationship',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: StreamBankConservationActionPermitList,
				customData: {
				}
			},
			{
				name: 'ContextNodeDetails',
				model: new ContextNodeDetails(),
				type: 'ParentPointer',
				using: 'contextNodeId',
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: true,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: '',
				groupTitle: null,
				itemTitle: 'ContextNodeDetails',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
];

const _fieldDefs = [
			{
				title: 'conservationActionId',
				placeholder: null,
				key: 'conservationActionId',
				isPrimaryKey: true,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.conservationActionId,
				setter: (x, y) => x.conservationActionId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'contextNodeId',
				placeholder: null,
				key: 'contextNodeId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.contextNodeId,
				setter: (x, y) => x.contextNodeId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'conservationActionTypeId',
				placeholder: null,
				key: 'conservationActionTypeId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.conservationActionTypeId,
				setter: (x, y) => x.conservationActionTypeId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Project',
				placeholder: null,
				key: 'projectId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 1,
				getter: (x) => x.projectId,
				setter: (x, y) => x.projectId = y,
				defaultValue: null,
				editor: 'ProjectFieldEditor',
				viewer: 'ProjectFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'locationId',
				placeholder: null,
				key: 'locationId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.locationId,
				setter: (x, y) => x.locationId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Location Description',
				placeholder: null,
				key: 'locationDescription',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: {
					requiresPermission: 'authenticated_user'
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 3,
				getter: (x) => x.locationDescription,
				setter: (x, y) => x.locationDescription = y,
				defaultValue: null,
				editor: 'TextAreaEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new RequiredValidator(),
					new MaxLengthValidator(65535),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'created',
				placeholder: null,
				key: 'created',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.created,
				setter: (x, y) => x.created = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
					new RequiredValidator(),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'modified',
				placeholder: null,
				key: 'modified',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.modified,
				setter: (x, y) => x.modified = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'deleted',
				placeholder: null,
				key: 'deleted',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.deleted,
				setter: (x, y) => x.deleted = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'deletedKey',
				placeholder: null,
				key: 'deletedKey',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.deletedKey,
				setter: (x, y) => x.deletedKey = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'contextPath',
				placeholder: null,
				key: 'contextPath',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.contextPath,
				setter: (x, y) => x.contextPath = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new RequiredValidator(),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'organizationId',
				placeholder: null,
				key: 'organizationId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.organizationId,
				setter: (x, y) => x.organizationId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Verified',
				placeholder: 'Not Verified',
				key: 'verifiedDate',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: 'This value is calculated based on the date of Confirmation Status section from  can only',
				requiresPermission: '__never_allowed__',
				group: '',
				groupTitle: null,
				displayOrder: 3,
				getter: (x) => x.verifiedDate,
				setter: (x, y) => x.verifiedDate = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
					new RequiredValidator(),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'usesSimplifiedEnvironmentalBenefits',
				placeholder: null,
				key: 'usesSimplifiedEnvironmentalBenefits',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.usesSimplifiedEnvironmentalBenefits,
				setter: (x, y) => x.usesSimplifiedEnvironmentalBenefits = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
];

export class ConservationAction extends BaseModel {
	constructor() {
		super();
	}

	get groupRenderers() {
		return {
		};
	}

	get recordValidators() {
		return this._recordValidators ?? ( this._recordValidators = [		]);
	}

	get associations() {
		return _associations;
	}
	get fieldDefs() {
		return _fieldDefs;
	}

}
